import { jsx as _jsx } from "react/jsx-runtime";
import Blog from "../../../../../common/others/blog/views/mobile/index.js";
import { blogMarketingMobileConverter } from "../../../../../../helpers/wrappers/marketing/blog/index.js";
import * as S from "./styled.js";
export const BlogMarketingMobile = (props)=>{
    const converter = blogMarketingMobileConverter(props);
    return /*#__PURE__*/ _jsx(S.BlogContainer, {
        children: /*#__PURE__*/ _jsx(Blog, {
            ...converter
        })
    });
};
export default BlogMarketingMobile;

//# sourceMappingURL=index.js.map